module.exports = __webpack_public_path__ + "static/media/loader.79fd4fe9.svg";